import { Controller } from "@hotwired/stimulus";
import { Scanner, QrCode } from "../plugins/scanner";

// Connects to data-controller="scanner-entrustments"
export default class extends Controller {
  static values = {
    readerId: String,
    cratePrefix: String,
    crateInstruction: String,
    shipmentPrefix: String,
    shipmentInstruction: String,
  };

  static targets = [
    "qrInstructions",
    "feedback",
    "message",
    "form",
    "shipmentId",
    "crateNumber",
    "manualBtn",
  ];

  connect() {
    // No prefix as there can be 2, let's validate in this controller
    this.scanner = new Scanner(this.readerIdValue, { qr: new QrCode() });
    this.steps = [this.cratePrefixValue, this.shipmentPrefixValue];
    this.inputTargets = (index) =>
      [this.crateNumberTarget, this.shipmentIdTarget][index];
    this.instructions = [
      this.crateInstructionValue,
      this.shipmentInstructionValue,
    ];
    this.expectedStep = 0;
    this.scan();
  }

  disconnect() {
    this.stop().then(() => (this.scanner = null));
  }

  quit(e) {
    e.preventDefault();
    this.stop().then(() => Turbo.visit(e.target.closest("a").href));
  }

  scan() {
    this.#scanQrCode();
  }

  async stop() {
    await this.scanner.stop();
  }

  async toggleTorch() {
    await this.scanner.toggleTorch();
  }

  resetForm() {
    if (this.hasFormTarget) {
      this.formTarget.reset();
    }
  }

  #submitForm() {
    if (this.hasFormTarget) {
      this.formTarget.requestSubmit();
      this.resetForm();
    }
  }

  #scanQrCode() {
    this.#showQrInstructions(this.instructions[this.expectedStep]);

    this.scanner.scan(
      this.scanner.qr,
      async (scannedString) => {
        const expectedPrefix = this.steps[this.expectedStep];
        const target = this.inputTargets(this.expectedStep);

        if (scannedString.startsWith(expectedPrefix)) {
          const regex = new RegExp(`^${expectedPrefix}`, "i");
          this.#setSuccess(scannedString);

          target.value = scannedString.replace(regex, "");

          if (this.expectedStep == 0) {
            this.#setManualUrlParam();
            this.expectedStep = 1;
            this.#showQrInstructions(this.instructions[this.expectedStep]);
            return;
          } else {
            this.expectedStep = 0;
            this.#showQrInstructions(this.instructions[this.expectedStep]);
            this.#submitForm();
          }
        }
      },
      (decodedResult) => {
        console.debug("invalid qr code:", decodedResult);
      },
    );
  }

  #showQrInstructions(message) {
    if (this.hasQrInstructionsTarget) {
      const wrapper = this.qrInstructionsTarget;
      const text = wrapper.firstElementChild;

      text.textContent = message;

      wrapper.classList.add("active");
    }
  }

  #setManualUrlParam() {
    if (this.hasManualBtnTarget && this.hasCrateNumberTarget) {
      const url = new URL(this.manualBtnTarget.href);
      url.searchParams.set(
        this.crateNumberTarget.name,
        this.crateNumberTarget.value,
      );

      this.manualBtnTarget.href = url.toString();
    }
  }

  #setSuccess(message) {
    if (this.hasFeedbackTarget) {
      this.feedbackTarget.classList.remove("d-none");

      const wrapper = this.feedbackTarget.querySelector(".feedback");
      if (wrapper) {
        wrapper.classList.remove("error");
        wrapper.classList.add("success");
      }

      const icon = this.feedbackTarget.querySelector(".icon");
      if (icon) {
        icon.innerHTML = '<i class="fa fa-check"></i>';
      }
    }

    if (this.hasMessageTarget) {
      this.messageTarget.textContent = message;
    }
  }
}
